import React from 'react';
import OKAPI from '@api';
import to from 'await-to-js';
import _get from 'lodash/get';
import Toast from '@libs/toast';

const JsonFormContext = React.createContext();

class JsonFormProvider extends React.Component {
    state = {
        isLoading: true, 
        isError: false,
        JSONSchema: {},
        UISchema: {}, 
        ErrorSchema: {},
        formData: {},
        search: {}
    }

    getSearchFormSchema = async(facilityId, params = {}) => {
        let search = {};
        try {
            const res = await OKAPI.qms.SearchPatientForm(facilityId, params);
            const statusOk = _get(res, 'status') === 200;
            if (statusOk) {
                search.JsonSchema = _get(res, 'data.data.json_schema') || {};
                search.UiSchema = _get(res, 'data.data.ui_schema') || {};
                search.FormData = _get(res, 'data.data.search_data') || {};
                this.setState({ search });
            }
        } catch (error) {
            Toast.show('Sepertinya ada masalah dengan koneksi internetnya, mohon periksa koneksi anda dan ulangi lagi', 'error', 3000);
        }
    }

    getFormSchema = async (facilityId, params = {}) => {
        let { JSONSchema, UISchema, ErrorSchema } = this.state;
        const [err, response] = await to(OKAPI.qms.JsonForm(facilityId, params));
        
        let isError = false;
        let res = response;
        if (err) {
            isError = true
            res = err;
        }

        if (response) {
            const datanya = _get(response, 'data.data') || {};
            JSONSchema = datanya.json_schema;
            UISchema = datanya.ui_schema;
            ErrorSchema = datanya.error_schema;
        }

        this.setState({
            isLoading: false,
            JSONSchema, 
            UISchema,
            isError,
            ErrorSchema
        })

        return res;
    }

    postFormData = () => {}

    render() {
        const value = {
            ...this.state,
            actions: {
                getFormSchema: this.getFormSchema, 
                postFormData: this.postFormData,
                getSearchFormSchema: this.getSearchFormSchema
            }
        };
        
        return (
            <JsonFormContext.Provider value={value}>{this.props.children}</JsonFormContext.Provider>
        );
    }
}

export { JsonFormProvider, JsonFormContext };